<template>
  <div class="wrapper--team">
    <div class="l-container">
      <div class="team-grid">
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">P Hemanth Bhargav</h3>
              <p class="member__title">Founder</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/p-hemanth-bhargav-0a5436201/?originalSubdomain=in"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTui63nOeAMmEwuS3Z2YiIQ4UPYbXjpbya5wa32tzwzEA&s"
            alt="BJ Pichman"
          />
        </div>

        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Subramanya Murali Kowsik</h3>
              <p class="member__title">President</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/godavarthi-subramanya-murali-kowsik-990a29214/"
                >Read More</a
              >
            </div>
          </div>
          <img src="../assets/CORE/kowsik.jpg" alt="Robert Finkel" />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">Palanati Sreekar</h3>
              <p class="member__title">Vice - President</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/sreekar-palanati-869298229/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2100030708_P SREEKAR_VICE PRESIDENT.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">S. Manish Babu</h3>
              <p class="member__title">Technical Lead</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/sujanimulk-manish-babu-757742226/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2100030513_S.MANISH BABU_TECH LEAD.jpeg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">CH. Venkata Praveen</h3>
              <p class="member__title">Non - Tech Lead</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/praveen-chennamsetty-7a0901235/"
                >Read More</a
              >
            </div>
          </div>
          <img src="../assets/CORE/praveen.jpg" alt="Robert Finkel" />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Surya Vishnu</h3>
              <p class="member__title">Secretary</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/ganimisetty-surya-vishnu-bab080256/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2100030156_SURYA VISHNU_SECRETARY.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Aditya Nagendra</h3>
              <p class="member__title">AI Director</p>
              <a
                class="member__link"
                href="https://in.linkedin.com/in/adithya-nagendra-gummadi-b61120226"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2100031347_ADITYA NAGENDRA G_AI DIRECTOR.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">K DeviSri Santosh</h3>
              <p class="member__title">DevOps Director</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/devi-sri-santosh-kola-a9735a226/"
                >Read More</a
              >
            </div>
          </div>
          <img src="../assets/CORE/santosh.jpg" alt="Robert Finkel" />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">D Samanvitha</h3>
              <p class="member__title">DS Director</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/samanvitha-dharmavarapu-1183ba248/"
                >Read More</a
              >
            </div>
          </div>
          <img src="../assets/CORE/samanvitha.jpg" alt="Robert Finkel" />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">S Sai Revanth</h3>
              <p class="member__title">IOT Director</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/sai-revanth-singavarapu-25229b202/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTui63nOeAMmEwuS3Z2YiIQ4UPYbXjpbya5wa32tzwzEA&s"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">Ch Venkata Prasanna</h3>
              <p class="member__title">Designs Director</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/prasanna-chennamsetty-0793a9244/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2100030097_CH.PRASANNA_DESIGN_DIRECTOR.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">M V N S Vyshnavi</h3>
              <p class="member__title">Draft Director</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/minnikanti-vyshnavi-192ab4225/"
                >Read More</a
              >
            </div>
          </div>
          <img src="../assets/CORE/vyshnavi.jpg" alt="Robert Finkel" />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Hema Venkata Sundar</h3>
              <p class="member__title">Marketing Director</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/sundargopaladasu-243983225/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2100030175_SUNDAR.G_MARKETING_DIRECTOR.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">B Meghana</h3>
              <p class="member__title">Relations Director</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/meghana-reddy-bhavanam-a79911226"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2100031805_B MEGHANA_RELATIONS DIRECTOR.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">K Manogna</h3>
              <p class="member__title">Professional Development</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/manogna-kothamasu-580454259/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200031032_K.Manogna_PROFESSIONAL_DEVELOPMENT_SOCIETY_CORE.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Nitish Kumar</h3>
              <p class="member__title">Lead AI</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/gurugubelli-nitish-kumar-785770286"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200032806_NITISH_KUMAR_AI_CORE.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Jashwanth</h3>
              <p class="member__title">Lead DS</p>
              <a class="member__link" href="">Read More</a>
            </div>
          </div>
          <img
            src="../assets/CORE/2200090081_G JASHWANTH_DS CORE.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">S Suhas</h3>
              <p class="member__title">Lead IOT</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/suhas-surampudi-a680b8255/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200031373_S SUHAS_IOT CORE.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">K Sanjay</h3>
              <p class="member__title">Lead Devops</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/sanjay-kamisetty-137aa7284/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200030928_SANJAY K_DEVOPS_CORE.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">Ch Vamsi Krishna</h3>
              <p class="member__title">Lead Design</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/vamsi-krishna-chepuri-b7bb27230/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200030073_CH VAMSI KRISHNA_DESIGN CORE.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Akhil</h3>
              <p class="member__title">Lead Draft</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/akhil-g-745524255/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200030074_G AKHIL_DRAFT CORE.jpg"
            alt="Robert Finkel"
          />
        </div>
        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">J V M Pujitha</h3>
              <p class="member__title">Lead Marketing</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/pujithavm-jangalapalli-a3486028a/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200030040_JVMPUJITHA_MARKETING_CORE.jpg"
            alt="Robert Finkel"
          />
        </div>

        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">T Jahnavi</h3>
              <p class="member__title">Lead Internal Relations</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/jahnavi-thadikamalla-367b0328a/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200031637_T JAHNAVI_INTERNAL RELATIONS.jpg"
            alt="Randy Mosher"
          />
        </div>

        <div class="team-grid__member hover">
          <div class="member__info">
            <div class="center-vert-content">
              <h3 class="member__name">G Anitha</h3>
              <p class="member__title">Lead External Relations</p>
              <a
                class="member__link"
                href="https://www.linkedin.com/in/gondi-anitha-chowdary-2aa77328a/"
                >Read More</a
              >
            </div>
          </div>
          <img
            src="../assets/CORE/2200031609_G ANITHA_EXTERNAL RELATIONS.jpg"
            alt="BJ Pichman"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamPage",
};
</script>

<style scoped>
/* Apply styles */
.wrapper--team {
  margin: 0;
  padding: 2rem 1rem;
  background-color: rgba(43, 46, 106, 0);
}

.l-container {
  margin: 0 auto;
}

@media screen and (min-width: 64em) {
  .l-container {
    max-width: 64rem;
  }
}

@media screen and (min-width: 75em) {
  .l-container {
    max-width: 75rem;
  }
}

.team-grid {
  margin: 0;
  text-align: center;
}

.team-grid:before,
.team-grid:after {
  content: " ";
  display: table;
}

.team-grid:after {
  clear: both;
}

.team-grid__member {
  font-family: "ff-tisa-web-pro";
  max-width: 100%;
  padding: 1rem;
  margin: 0 2rem 2rem;
  display: inline-block;
  float: none;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  height: 400px; /* Set a fixed height for the card */
}

@media screen and (min-width: 28em) {
  .team-grid__member {
    width: 49%;
    max-width: none;
  }
}

@media screen and (min-width: 42em) {
  .team-grid__member {
    width: 32.5%;
  }
}

@media screen and (min-width: 62em) {
  .team-grid__member {
    width: 24%;
  }
}

.team-grid__member img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensure the image covers the entire container */
  border: 8px solid #000000;
  box-sizing: content-box;
  display: block;
}

.member__info {
  color: #fff;
  height: 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.371);
  backface-visibility: hidden;
  transition: opacity 0.4s ease-in-out;
  box-sizing: border-box;
}

.member__name {
  color: #ffffff;
  font-size: 1.5rem;
  letter-spacing: 1px;
  line-height: 1.2rem;
  margin-bottom: 0;
  padding: 0 12px;
}

.member__title {
  margin-bottom: 0.75rem;
  font-size: 0.8rem;
  font-weight: normal;
  line-height: 1rem;
  padding: 0 1.5rem;
}

a.member__link {
  background: #79c3e9;
  color: #fff;
  border-radius: 2px;
  border: 0;
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  padding: 8px;
  text-align: center;
  text-decoration: none;
}

.team-grid__member:hover .member__info {
  opacity: 5;
}

.member__info:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -0.25em;
}

.center-vert-content {
  display: inline-block;
  vertical-align: middle;
}
</style>
